<template>
    <rkm-form-input
        v-if="!!label || label === false"
        :label="label"
        :value="value"
        :append="append"
        disabled
    />

    <rkm-form-input
        v-else
        :value="value"
        :append="append"
        disabled
    />
</template>

<script>
export default {
    props: {
        label: { type: [String, Boolean], default: '' },
        value: { type: [String, Number] },
        append: { type: String },
    },
}
</script>